import { Users, TrendingUp, BarChart3 } from "lucide-react";
import Reveal from "@/components/escape21/Reveal";

const FORMATS = [
  {
    icon: Users,
    title: "collabs e campanhas",
    desc: "parceria autêntica que conecta tua marca com uma audiência que já compra o que eu recomendo.",
  },
  {
    icon: TrendingUp,
    title: "conteúdo patrocinado",
    desc: "teu produto integrado de forma natural, no meu tom, sem parecer anúncio forçado.",
  },
  {
    icon: BarChart3,
    title: "ativações e eventos",
    desc: "presença ao vivo que aproxima a marca do público e gera conteúdo de verdade.",
  },
];

const Collab = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-5xl">
      <Reveal className="text-center">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          formatos
        </span>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          como a gente pode <span className="e21-serif text-green-400">trabalhar</span> junto.
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
        {FORMATS.map(({ icon: Icon, title, desc }, i) => (
          <Reveal
            key={title}
            delay={i * 100}
            className="rounded-2xl border border-white/10 bg-white/5 p-8 text-center"
          >
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-green-400/10">
              <Icon size={26} className="text-green-400" />
            </div>
            <h3 className="mt-5 text-lg font-bold tracking-[-0.02em] text-white">{title}</h3>
            <p className="mt-3 text-sm text-white/60">{desc}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Collab;
